// styles.js - All CSS constants extracted

export const mapContainerStyle = {
  width: "100%",
  height: "auto",
  minHeight: "500px",
  border: "1px solid #000000",
  // marginTop: "20px",
  borderRadius: "20px",
  overflow: "hidden",
  boxSizing: "border-box",
};

export const mapStyles = [
  {
    featureType: "all",
    elementType: "all",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ visibility: "on" }, { color: "black" }],
  },
];

export const mapOptions = {
  disableDefaultUI: true,
  zoomControl: true,
  streetViewControl: true,
  fullscreenControl: true,
  mapTypeControl: false,
  gestureHandling: "greedy",
  minZoom: 15,
  maxZoom: 40,
  animatedZoom: true,
  maxZoomRectangleSize: 8000,
};

export const vehicleInfoBoxStyle = {
  borderRadius: "10px",
  margin: "20px 0px",
  padding: "12px 16px",
  backgroundColor: "#FFFFFF",
  border: "1px solid #A5DCF3",
  boxShadow: "-2px 1px 5px 1px #00000040",
};

export const vehicleHeaderStyle = {
  minHeight: "48px",
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  justifyContent: { xs: "center", sm: "left" },
  alignItems: { xs: "flex-start", sm: "center" },
  padding: { xs: "10px 16px", sm: "12px 16px" },
  background: "#E8EAEE",
  boxShadow: "0px 2px 5px 0px #00000040",
  gap: { xs: 1, sm: 30 },
};

export const labelTextStyle = {
  color: "#414958",
  fontFamily: "Roboto",
  fontWeight: 400,
  fontSize: { xs: "16px", sm: "18px", md: "20px" },
  lineHeight: "100%",
  letterSpacing: "0%",
};

export const valueTextStyle = {
  fontFamily: "Roboto",
  fontWeight: 600,
  fontSize: { xs: "16px", sm: "18px", md: "20px" },
  lineHeight: "100%",
  color: "#183059",
  letterSpacing: "0%",
  ml: 1,
  textOverflow: "ellipsis",
  overflow: "hidden",
};

export const stopLabelStyle = {
  position: "absolute",
  left: "50%",
  transform: "translateX(-50%)",
  backgroundColor: "white",
  padding: "4px 8px",
  borderRadius: "4px",
  fontSize: "12px",
  fontWeight: "500",
  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
  whiteSpace: "nowrap",
  zIndex: 1000,
};

export const vehicleLabelStyle = {
  position: "absolute",
  top: "-10px",
  left: "50%",
  transform: "translateX(-50%)",
  color: "rgb(0, 0, 0)",
  fontSize: "10px",
  fontWeight: 600,
  fontFamily: "Arial, sans-serif",
  lineHeight: "14.06px",
  padding: "8px",
  textAlign: "center",
  whiteSpace: "nowrap",
  backgroundColor: "#20A8E0",
  borderRadius: "8px",
  zIndex: 1000,
  border: "1px solid black",
};